var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconNavPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4923 7.75149L12.219 2.78315C11.1923 1.97482 9.75812 1.97648 8.72979 2.78482L2.45812 7.75149C2.09728 8.03732 2.03562 8.56151 2.32145 8.92234C2.60728 9.28318 3.13145 9.34234 3.49228 9.05818L3.59728 8.97568V14.6465C3.59728 16.3973 5.02312 17.8215 6.77562 17.8215H14.1748C15.9273 17.8215 17.3531 16.3973 17.3531 14.6465V8.97568L17.4581 9.05818C17.6106 9.17984 17.7931 9.23818 17.9748 9.23818C18.2206 9.23818 18.464 9.12984 18.629 8.92234C18.914 8.56151 18.8531 8.03732 18.4923 7.75149Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72979 2.78618C9.75271 1.97752 11.1972 1.97752 12.2201 2.78618L18.4922 7.75111C18.853 8.03677 18.914 8.56086 18.6284 8.9217C18.3427 9.28261 17.8186 9.34353 17.4577 9.05786L11.1865 4.09365C11.1865 4.09366 11.1865 4.09363 11.1865 4.09365C10.7695 3.76399 10.1805 3.76394 9.76346 4.0936C9.76346 4.09361 9.76346 4.09358 9.76346 4.0936L3.49219 9.05786C3.13134 9.34353 2.60723 9.28261 2.32158 8.9217C2.03592 8.56086 2.09688 8.03677 2.45774 7.75111L8.72979 2.78618Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconNavPanel);
export default __webpack_public_path__ + "static/media/home_icon_nav_panel.1080ed78151914b5fd06987b44d8e697.svg";
export { ForwardRef as ReactComponent };